import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

/**
 * Bridges the legacy (old frontend system) `backstage-plugin-jfrog-artifactory-libs`
 * plugin onto the new Backstage frontend system. The plugin ships no `/alpha` export,
 * so the page is wired manually here:
 *
 * - `/libver` page route is recreated via `PageBlueprint`, lazily rendering the
 *   plugin's legacy `JFrogLibVerPage` React component with the same `title` prop
 *   used in the old app (`"JLL Artifactory"`).
 * - No API registration is needed — the plugin fetches data via the Backstage
 *   proxy (`/api/proxy/jfrog`) using the built-in `fetchApi`, so no custom `apiRef`
 *   is exposed or required.
 */

/** Lazily loads the JFrog Lib Ver page element. */
export const jfrogLibVerPageLoader = () =>
  import('backstage-plugin-jfrog-artifactory-libs').then(m => (
    <m.JFrogLibVerPage title="JLL Artifactory" />
  ));

const jfrogLibVerPage = PageBlueprint.make({
  name: 'jfrog-libver',
  params: { path: '/libver', loader: jfrogLibVerPageLoader },
});

/**
 * Module contributing the `backstage-plugin-jfrog-artifactory-libs` page route.
 * Targets `pluginId: 'app'` so the route is app-scoped.
 */
export const jfrogLibsBridgeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [jfrogLibVerPage],
});
